import React from 'react';

const EstadoBloqueado = (props) => {
    return (
        <div className="dropdown state pull-right" id={"state-block-" + props.ID}>
            <button type="button" data-toggle="dropdown" data-target={"#state-block-" + props.ID}
                className="btn btn-cta btn-sm btn-blocked">BLOQUEADO</button>
            <ul className="dropdown-menu">
                <li className="bottom-separator-xs">
                    <p>{"Bloqueado por " + props.Nombre + " el " + props.Fecha + " a las " + props.Hora}</p>
                    <p className="state-break"><i>{props.Motivo}</i></p>
                </li>
            </ul>
        </div>
    );
}

export default EstadoBloqueado;
